import { Tabs as AntdTabs } from "antd";
import { CMP_PREFIX } from "@/base/constant";
import type { GetProps } from "antd";

export type TabsProps = Partial<GetProps<typeof AntdTabs>>;

export const tabsPrefixCls = `${CMP_PREFIX}-tabs`;

export const Tabs = ({ ...props }: TabsProps) => {
  return <AntdTabs {...props} />;
};
